import { useSearchParams } from 'react-router-dom';
import KnowledgeMapIcon from '../os/knowledgeMap/KnowledgeMapIcon';
import { MAP_QUERY_PARAM } from '../os/landingDecision';
import { useKnowledgeMapEnabled } from '../utils/knowledgeMapFlag';
import { isWebGL2Supported } from '../utils/webglDetection';

/**
 * mcgraw-hill: the knowledge map's button in the desktop header, right of the
 * Clinical / Study toggle, so it stays put once a chat has started (the
 * desktop's own button sits on the empty greeting, which a chat replaces).
 * It asks for the map the way a demo link does (`/?map`): the desktop owns
 * the map and opens it, then drops the ask from the URL.
 */
const McGrawHillMapButton = () => {
  const [, setSearchParams] = useSearchParams();
  const isMapAvailable = useKnowledgeMapEnabled() && isWebGL2Supported();

  if (!isMapAvailable) return null;

  return (
    <button
      aria-label="Knowledge map"
      className="flex h-9 w-9 shrink-0 items-center justify-center rounded-full border border-border-subtle bg-surface-raised/60 text-fg-secondary shadow-low backdrop-blur-xl transition-colors hover:bg-surface-highlight hover:text-fg-primary focus-visible:ring-2 focus-visible:ring-ring focus-visible:outline-none"
      data-knowledge-map-entry="header"
      onClick={() =>
        setSearchParams((current) => {
          const next = new URLSearchParams(current);
          next.set(MAP_QUERY_PARAM, '1');
          return next;
        })
      }
      title="Knowledge map"
      type="button"
    >
      <KnowledgeMapIcon />
    </button>
  );
};

export default McGrawHillMapButton;
